import { render, staticRenderFns } from "./NotaFiscal.vue?vue&type=template&id=0361355e"
import script from "./NotaFiscal.vue?vue&type=script&lang=js"
export * from "./NotaFiscal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports